import { io } from 'socket.io-client';

export default class NotificationsClient {
   constructor({ onNotification, onMarkRead, onMarkAllRead }) {
      this.onNotification = onNotification;
      this.onMarkRead = onMarkRead;
      this.onMarkAllRead = onMarkAllRead;
      this.socket = null;
   }

   start() {
      this.socket = io(App.realtimeHost, {
         transports: ['websocket', 'polling'],
      });

      this.socket.on('connect', () => {
         this.socket.emit('subscribe', { room: App.socketioRoom });
      });

      this.socket.on('notification', notification => {
         switch (notification.event) {
            case 'notification': {
               this.onNotification(notification);
               break;
            }
            case 'markRead': {
               this.onMarkRead(notification.notificationSigs);
               break;
            }
            case 'markAllRead': {
               this.onMarkAllRead();
               break;
            }
         }
      });
   }

   static markRead(id, options = {}) {
      new Request.API_2_0('notifications?ids=' + id, {
         method: 'GET',
         ...options,
      }).send();
   }

   static markAllRead(options = {}) {
      new Request.API_2_0('notifications/all', {
         method: 'DELETE',
         ...options,
      }).send();
   }
}
